import {
  compose,
  setDisplayName,
  setPropTypes,
  withHandlers,
  withProps,
  withPropsOnChange,
  withStateHandlers,
} from 'recompose';
import { isFunction } from 'ramda-adjunct';
import { canItemsBeExpanded } from '../../utils/media-manager-sdk/items';
import { callOrUse } from '../../utils/callOrUse';
import { array, bool, func } from 'prop-types';
import {
  IExpandedViewControllerOuter,
  TExpandedViewState,
  TExpandedViewStateController,
  TExpandedViewStateUpdater,
  TGetOptions,
} from './withExpandedViewController.types';
import omitProps from '@hocs/omit-props';
import { T } from 'ramda';

export const withExpandedViewController = (getOptions: TGetOptions = {}, getOptionsDeps?: string[]) =>
  compose<TExpandedViewStateController, IExpandedViewControllerOuter>(
    setPropTypes({
      selectedItems: array.isRequired,
      hasSelectedItems: bool.isRequired,
      trackActionsDone: func.isRequired,
    }),
    setDisplayName('withExpandedViewController'),
    withPropsOnChange(getOptionsDeps || T, (props) => ({ expandedViewOptions: callOrUse(getOptions, props) })),
    withStateHandlers<TExpandedViewState, TExpandedViewStateUpdater, TExpandedViewState & TExpandedViewStateUpdater>(
      {
        isInExpandedMode: false,
      },
      {
        openExpandedView: () => () => ({ isInExpandedMode: true }),
        closeExpandedView: () => () => ({ isInExpandedMode: false }),
      },
    ),
    withProps(({ selectedItems }) => ({
      canItemsBeExpanded: canItemsBeExpanded(selectedItems),
    })),
    withHandlers({
      openExpandedView:
        ({ openExpandedView, expandedViewOptions: { onOpen } }) =>
        () => {
          if (isFunction(onOpen)) {
            onOpen();
          }
          openExpandedView();
        },
      closeExpandedView:
        ({ closeExpandedView, expandedViewOptions: { onClose } }) =>
        () => {
          if (isFunction(onClose)) {
            onClose();
          }
          closeExpandedView();
        },
    }),
    withHandlers({
      toggleExpandedView:
        ({ isInExpandedMode, hasSelectedItems, canItemsBeExpanded, closeExpandedView, openExpandedView }) =>
        () => {
          if (isInExpandedMode) {
            closeExpandedView();
          } else if (hasSelectedItems && canItemsBeExpanded) {
            openExpandedView();
          }
        },
    }),
    omitProps('expandedViewOptions'),
  );
